@let stringValue = value();
@if(stringValue) {
<blockquote class="border-start border-4 border-grey ps-3 mb-0 text-muted">{{ stringValue }}</blockquote>
} @else {
  -
}
